/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { connect } from 'react-redux'

const AddAnnotationToDocumentModal = (props) => {
    const [annotation, setAnnotation] = useState('');

    const saveDocumentAnnotation = async () => {
        const data = {
            fileMetaData: props.id,
            annotation: annotation,
            user: props.userReducer.user
        }

        fetch(window.location.protocol + '//' + window.location.host + '/api/archive/save_document_annotiation', {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(
                (result) => {
                    props.toggle();
                })
            .catch(error => {
                console.error(error);
            });
    }
    return (
        <div>
            <Modal isOpen={props.visible} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Add annotation to document</ModalHeader>
                <ModalBody>
                    <Input
                        value={annotation}
                        onChange={(e) => setAnnotation(e.target.value)}
                        type="textarea"
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => saveDocumentAnnotation()}>Save</Button>
                    <Button color="secondary" onClick={props.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default connect(state => state)(AddAnnotationToDocumentModal);